import { createWithEqualityFn as create } from 'zustand/traditional';

type RecaptchaState = {
  shouldLoadRecaptcha: boolean;
  recaptchaReady: boolean;
  setRecaptchaReady: (ready: boolean) => void;
  setShouldLoadRecaptcha: () => void;
};

/**
 * This store is only to be used to store BASIC boolean logic for external services.
 * If further logic is needed, create a separate store for that service.
 */
export const useExternalServiceStore = create<RecaptchaState>((set) => ({
  shouldLoadRecaptcha: false,
  recaptchaReady: false, // initial state
  setRecaptchaReady: (ready) => set({ recaptchaReady: ready }),
  setShouldLoadRecaptcha: () => set({ shouldLoadRecaptcha: true }),
}));
